import React from 'react'
import Card from 'atoms/Card'
import Link from './Link'

export default props => (
  <Card {...props} component={Link} />
)
